import { render, staticRenderFns } from "./ProfileUserMenu.vue?vue&type=template&id=a213c454&scoped=true&"
import script from "./ProfileUserMenu.vue?vue&type=script&lang=js&"
export * from "./ProfileUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUserMenu.vue?vue&type=style&index=0&id=a213c454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a213c454",
  null
  
)

export default component.exports